import { render, staticRenderFns } from "./MetaFields.vue?vue&type=template&id=1b9abd4e"
import script from "./MetaFields.vue?vue&type=script&lang=js"
export * from "./MetaFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9abd4e')) {
      api.createRecord('1b9abd4e', component.options)
    } else {
      api.reload('1b9abd4e', component.options)
    }
    module.hot.accept("./MetaFields.vue?vue&type=template&id=1b9abd4e", function () {
      api.rerender('1b9abd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/optimizely/MetaFields.vue"
export default component.exports